import { BACKEND_BASE_URL} from "../constants"


function getLoginData() {
  if (JSON.parse(localStorage.getItem("remember-me")) ? true : false) {
    return JSON.parse(localStorage.getItem("login-data"))
  } else {
    return JSON.parse(sessionStorage.getItem("login-data"))
  }
}

export const fetchSubscriptions = async (data) => {

  const queryParams = new URLSearchParams(data).toString();
  const response = await fetch(`${BACKEND_BASE_URL}/subscriptions?${queryParams}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Auth-Token': getLoginData()
    },
  });
  if (!response.ok) {
    throw new Error(`Error: ${response.status}`);
  }
  return await response.json();
};


export const createSubscription = async (data) => {

    const queryParams = new URLSearchParams(data).toString();
    const response = await fetch(`${BACKEND_BASE_URL}/subscriptions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Auth-Token': getLoginData()
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    return await response;
};
  
export const deleteSubscription = async (data) => {

    const queryParams = new URLSearchParams(data).toString();
    const response = await fetch(`${BACKEND_BASE_URL}/subscriptions`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Auth-Token': getLoginData()
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    return await response;
};

async function adminRequest(path, method, body, { refresh } = {}) {
  const url = refresh
    ? `${BACKEND_BASE_URL}${path}${path.includes("?") ? "&" : "?"}refresh=1`
    : `${BACKEND_BASE_URL}${path}`;
  const response = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Auth-Token': getLoginData()
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || `Error: ${response.status}`);
  }
  return payload;
}

export const fetchAdminUsers = async ({ refresh } = {}) =>
  adminRequest('/admin/users', 'GET', undefined, { refresh });

export const fetchAdminGroups = async ({ refresh } = {}) =>
  adminRequest('/admin/groups', 'GET', undefined, { refresh });

export const fetchAdminGroupConfig = async ({ refresh } = {}) =>
  adminRequest('/admin/groups', 'GET', undefined, { refresh });

export const saveAdminGroupConfig = async (groups) =>
  adminRequest('/admin/groups', 'PUT', { groups });

export const fetchAdminFolders = async ({ refresh } = {}) =>
  adminRequest('/admin/folders', 'GET', undefined, { refresh });

export const saveAdminFolders = async (folders) =>
  adminRequest('/admin/folders', 'PUT', { folders });

export const createAdminUser = async (data) => adminRequest('/admin/users', 'POST', data);

export const updateAdminUser = async (data) => adminRequest('/admin/users', 'PUT', data);

export const fetchImportableUsers = async () =>
  adminRequest('/admin/users/importable', 'GET');

export const importTableauUsers = async (users, convertToPortalAuth) =>
  adminRequest('/admin/users/import', 'POST', {
    users,
    convert_to_portal_auth: Boolean(convertToPortalAuth),
  });

export const setAdminUserStatus = async (userEmail, isActive) =>
  adminRequest('/admin/users/status', 'POST', {
    user_email: userEmail,
    is_active: isActive,
  });

export const deleteAdminUser = async (userEmail) =>
  adminRequest('/admin/users', 'DELETE', {
    user_email: userEmail,
  });

export const impersonateUser = async (userEmail) =>
  adminRequest('/admin/impersonate', 'POST', {
    user_email: userEmail,
  });

export const sendAdminWelcomeEmail = async (userEmail) =>
  adminRequest('/admin/users/welcome-email', 'POST', {
    user_email: userEmail,
  });

export const deleteSubscriptionWT = async (data) => {

  const queryParams = new URLSearchParams(data).toString();
  const response = await fetch(`${BACKEND_BASE_URL}/unsubscribe`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error(`Error: ${response.status}`);
  }
  return await response;
};

